/**
 * Registers the inbound Web Share Target worker on `/mobile/` only.
 * Does not touch `/sw.js` (VAPID) or the FCM messaging worker.
 */
const SHARE_TARGET_SW_URL = '/share-target-sw.js'
const SHARE_TARGET_SW_SCOPE = '/mobile/'

export function registerShareTargetWorker(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return

  void navigator.serviceWorker
    .register(SHARE_TARGET_SW_URL, {
      scope: SHARE_TARGET_SW_SCOPE,
      updateViaCache: 'none',
    })
    .then((registration) => {
      void registration.update().catch(() => undefined)
    })
    .catch(() => undefined)
}
